// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"ac051300","501":"65cf264f","631":"8af51a25"}[chunkId] + ".chunk.css";
};